var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"primary-button text-decoration-none my-4 my-lg-5 px-4",attrs:{"download":_vm.filename,"href":_vm.href,"data-key":_vm.dataKey}},[_vm._t("default",[_vm._v("Save image")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }